<template>
  <SiteHeader></SiteHeader>
  <router-view></router-view>
  <SiteFooter></SiteFooter>
</template>

<script>
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

export default {
  name: 'App',
  components: {
    SiteHeader, SiteFooter
  }
}
</script>

<style>
</style>
